import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// Redux
import { connect } from "react-redux";

// Components
import IkTable from "@Components/IkTable";

// Utils
import dataHandler from "@Utils/dataHandler";

// Styles
import styles from "./styles.module.css";

const ForDays = ({ dispatch, userName, companyName, onOpenFilterModal, appliedFilters = {} }) => {
	const defaultParams = { page: 1, orderDir: "desc", rows: 20 };
	const [filteredItems, setFilteredItems] = useState([]);
	const [filteredCount, setFilteredCount] = useState(0);
	const [filteredPrintData, setFilteredPrintData] = useState([]);
	const [lastParams, setLastParams] = useState(defaultParams);
	const [sumData, setSumData] = useState({});

	useEffect(() => {
		const mergedParams = { ...defaultParams, ...appliedFilters };

		(async () => {
			try {
				const response = await dataHandler({
					dispatch,
					method: "GET",
					url: "/reports/historic/summary/daily",
					params: mergedParams,
				});

				setFilteredItems(response.items);
				setFilteredCount(response.count);
				setSumData(response.total || {});
				setLastParams(mergedParams);
			} catch (error) {
				setFilteredItems([]);
				setFilteredCount(0);
				setSumData({});
			}
		})();
	}, [appliedFilters]);

	const handlerData = async (params = defaultParams, printable) => {
		const mergedParams = {
			...params,
			...appliedFilters,
			fields: "user.fullName",
		};

		const data = await dataHandler({
			method: "GET",
			dispatch,
			url: "/reports/historic/summary/daily",
			params: mergedParams,
		});

		if (printable) {
			setFilteredPrintData(data.items);
		} else {
			setFilteredItems(data.items);
			setFilteredCount(data.count);
			setLastParams(mergedParams);
			setSumData(data.total || {});
		}
	};

	const handleRefreshData = () => {
		handlerData(lastParams);
	};

	const renderTopButtons = () => {
		const buttons = [
			{
				icon: "filter",
				className:
					Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0
						? styles.filterButtonActive
						: styles.filterButton,
				onClick: onOpenFilterModal,
				content: Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0 ? "Filtrando" : "",
				label: Object.keys(typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {}).length > 0 ? "Filtrando" : "",
				showLabel: true,
				componentType: "button",
			},
			{
				icon: "refresh",
				className: styles.refreshButton,
				onClick: handleRefreshData,
			},
		];

		const filters = typeof appliedFilters !== "undefined" && appliedFilters ? appliedFilters : {};
		const dateRange = filters.createdDate || filters.closeDate;
		if (dateRange) {
			const formatDate = (d) => {
				if (!d) return "";
				const parts = d.split("-");
				if (parts.length === 3) return `${parts[2]}/${parts[1]}/${parts[0]}`;
				return d;
			};
			const [start, end] = dateRange.split(",");
			let value = formatDate(start);
			const today = new Date();
			const currentEnd =
				end || `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
			if (currentEnd && start !== currentEnd) value += ` al ${formatDate(currentEnd)}`;

			buttons.push({
				componentType: "Label",
				title: "Fecha:",
				value,
			});
		}

		return buttons;
	};

	return (
		<div className={styles.container}>
			<div className={styles.containerTableGroup}>
				<div className={styles.tableGroupList}>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Usuario",
								key: "user.fullName",
								format: "string",
								headerPosition: "center",
								dataPosition: "left",
								width: 1,
							},
							{
								label: "Total",
								key: "total",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},

							{
								label: "1",
								key: "day1",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "2",
								key: "day2",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "3",
								key: "day3",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "4",
								key: "day4",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "5",
								key: "day5",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},

							{
								label: "6",
								key: "day6",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "7",
								key: "day7",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "8",
								key: "day8",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "9",
								key: "day9",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "10",
								key: "day10",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "11",
								key: "day11",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "12",
								key: "day12",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "13",
								key: "day13",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "14",
								key: "day14",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "15",
								key: "day15",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "16",
								key: "day16",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "17",
								key: "day17",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "18",
								key: "day18",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "19",
								key: "day19",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "20",
								key: "day20",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "21",
								key: "day21",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "22",
								key: "day22",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "23",
								key: "day23",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "24",
								key: "day24",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "25",
								key: "day25",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "26",
								key: "day26",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "27",
								key: "day27",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "28",
								key: "day28",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "29",
								key: "day29",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "30",
								key: "day30",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "31",
								key: "day31",
								format: "blankZero",
								headerPosition: "center",
								dataPosition: "center",
								width: 1,
							},
						]}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						widthAuto
						print={{
							printHeader: {
								company: companyName,
								title: "Por Días",
								user: userName,
							},
						}}
						searcher={{
							searchable: true,
							searchPosition: "flex-start",
							searchDisabled: false,
							filterButton: false,
							width: "40rem",
						}}
						topButtons={renderTopButtons()}
						sumData={sumData}
					/>
				</div>
			</div>
		</div>
	);
};

function mapStateToProps({ user, company }) {
	return {
		userName: user.name,
		companyName: company.name,
	};
}

ForDays.propTypes = {
	companyName: PropTypes.string,
	userName: PropTypes.string,
	dispatch: PropTypes.func,
	onOpenFilterModal: PropTypes.func,
	appliedFilters: PropTypes.object,
};

export default connect(mapStateToProps)(ForDays);
